module.exports = __webpack_public_path__ + "static/media/search.076b54e3.svg";